import { fetchAuthSession } from 'aws-amplify/auth';

export const getAccessToken = async (): Promise<string> => {
  const session = await fetchAuthSession();
  const token = session.tokens?.accessToken.toString();
  if (!token) {
    throw new Error('User is not authenticated');
  }
  return token;
};
